// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3TPrL","col":"styles_col__1aYsb"};